export default __webpack_public_path__ + "navigation-examples-basic-960-a5b63f9ecf8e7af80d8bea242fec1ab0.webp";